import React from "react";
import JobPreviewModal from "./JobPreviewModal";

// Map-focused job details modal — identical content, sections and actions to
// the standard JobPreviewModal (fully reused), plus an always-visible quick
// technician assignment bar pinned near the top that saves immediately.
const MapJobDetailsModal = ({ teamMembers = [], onAssigned, ...rest }) => (
  <JobPreviewModal {...rest} quickAssign={{ teamMembers, onAssigned }} />
);

export default MapJobDetailsModal;
